module.exports = __webpack_public_path__ + "static/media/Boosted Brown4Web.1e3e4bb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/Boosted Brown4Web.mp3
// module id = U3G9
// module chunks = 12